import { put, takeLatest } from "redux-saga/effects";
import { axiosInstance } from "../../config/axios";
import { apiEndpoints } from "../../utils/api-endpoints";
import { createErrorAction } from '../reducers/errorSlice';
import {
    getLogsSuccess,
    getLogsFailed,
    createLogSuccess,
    createLogFailed,
    clearLogsSuccess,
    clearLogsFailed
} from "../reducers/logSlice";

function* getLogs(action: any): any {
    try {
        const params = action.payload || {};
        const response = yield axiosInstance.get(apiEndpoints.logs.list, { params });
        yield put(getLogsSuccess(response.data));
    } catch (error) {
        yield put(getLogsFailed());
        yield put(createErrorAction(error, 'log/getLogs'));
    }
}

function* createLog(action: any): any {
    try {
        const response = yield axiosInstance.post(apiEndpoints.logs.create, action.payload);
        yield put(createLogSuccess(response.data));
    } catch (error) {
        yield put(createLogFailed());
        yield put(createErrorAction(error, 'log/createLog'));
    }
}

function* clearLogs(): any {
    try {
        yield axiosInstance.delete(apiEndpoints.logs.clear);
        yield put(clearLogsSuccess());
    } catch (error) {
        yield put(clearLogsFailed());
        yield put(createErrorAction(error, 'log/clearLogs'));
    }
}

export function* watchLogSaga() {
    yield takeLatest('log/getLogs', getLogs);
    yield takeLatest('log/createLog', createLog);
    yield takeLatest('log/clearLogs', clearLogs);
} 